// extracted by mini-css-extract-plugin
export default {"showOnHoverOnly":"ProjectTrafficLightStatusSwitcherCell_showOnHoverOnly__l1Mqn"};